import { computed, reactive, ref } from 'vue'
import * as api from '@/modules/audit-logs/api'
import * as types from './types'
import { AuditLogsListFilterParameters } from '@/views/_shared/search-list/types'

export * from './types'

export const operatorOriginOptions = [
    {
        value: types.OperatorOrigin.Employee,
        label: 'Employee'
    },
    {
        value: types.OperatorOrigin.Customer,
        label: 'Customer'
    },
    {
        value: types.OperatorOrigin.Cron,
        label: 'Cron'
    },
    {
        value: types.OperatorOrigin.Console,
        label: 'Console'
    },
    {
        value: types.OperatorOrigin.Api,
        label: 'Api'
    },
    {
        value: types.OperatorOrigin.Aesir,
        label: 'Aesir'
    }
]

const auditLogs = ref<types.AuditLog[]>([])
const auditLogsCount = ref<number>()

const defaultSortBy = 'occurrence desc'

export const auditLogsFilter = reactive<AuditLogsListFilterParameters>({
    search: {
        search: '',
        id: '',
        operatorName: '',
        operatorOrigin: '',
        action: '',
        requestId: '',
        occurrence: ''
    },
    sortBy: null,
    limit: 10,
    offset: 0
})

const getAuditLogs = () => {
    return api.getAuditLogsList(
        auditLogsFilter.search,
        auditLogsFilter.sortBy || defaultSortBy,
        auditLogsFilter.limit,
        auditLogsFilter.offset
    ).then(
        auditLogsList => {
            auditLogs.value = auditLogsList.results
            auditLogsCount.value = auditLogsList.count
        }
    )
}

export function useAuditLogsModule () {
    return {
        auditLogs: computed(() => auditLogs.value),
        auditLogsCount: computed(() => auditLogsCount.value),
        getAuditLogs,
        getAuditLog: api.getAuditLog,
        auditLogsFilter
    }
}
